import i18next from "i18next"

const listLangs = {}

// Importa todos os arquivos dentro de cada diretório da linguagem
// noinspection JSUnresolvedFunction
const requires = {
    'pt-BR': require.context('./pt_BR/', true, /\.js$/),
    en: require.context('./en/', true, /\.js$/),
    es: require.context('./es/', true, /\.js$/)
}

// Importação dinâmica usando o nome dos arquivos como os namespaces da linguagem
for (let initial in requires) {
    listLangs[initial] = {}

    requires[initial].keys().forEach(fileName => {
        let ns = fileName.replace('./', '').replace('.js', '').replace('-', '_')
        listLangs[initial][ns] = requires[initial](fileName).default
    })
}

i18next.init({
    lng: getUserLang(),
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',
    nsSeparator: ':',
    defaultNS: 'common',
    resources: listLangs
})

function getUserLang() {
    return document.documentElement.lang
}

export { getUserLang }

export default i18next
